import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';



import { Selected_Index } from "../../../constants/external-constants";
import DebitorDetailForm from "../../external/recharge/debitor-catalogue/modal-form/details/form/debitor-detail-form.component";
import DebitorCatalogueHistory from "../../external/recharge/debitor-catalogue/modal-form/history/debitor-catalogue-history.component";
import DetailContainer from "../Layout/details/DetailsLayout.component";
import ModalContainer from "../modal/modal-container/modal-container.component";
import { NoSubscription } from "../../external/dashboard/no-subscription/no-subscription.component";
import { TRANSLATIONS as translation } from "../../../utils/constant.utils";
import { checkCountryCodeFormat, checkVatPercentValue, convertToDecimal } from "../../../utils/helpers.utils";
import { debitorCatalogueActions } from "../../../store/external/recharge-reducer/debitor-catalogue-reducer/debitor-catalogue.reducer";



class DebitorModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displaySearch: false,
            detailsView: false,
            debitorId: 0,
            userId: 0,
            showModal: false,
            showModalForm: false,
            isNew: false,
            isSaving: false,
            debitorAlreadyExist: false,
            percentExceed: false,
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            confirmationModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
        }
        this.ConfirmationModal = React.createRef();
    }

    componentDidMount() {
        this.getDebitorCatalogueDetails();
    }

    componentWillUnmount() {
        this.props.setDefaultDebitorCatalogue();
    }


    loading = () => {
        return (
            <NoSubscription />
        );
    }


    handleSelectedIndex = (index) => {
        this.setState({
            contentIndex: index,
            debitorAlreadyExist: false,
            percentExceed: false,
        })
    }

    getDebitorCatalogueDetails() {
        const { getDebitorCatalogue, getDebitorCatalogueDropdownList, getDebitorCatalogueForm, getCountriesList } = this.props;

        const DebitorId = this.props.mappingInformationList?.datatable[0]?.dataItem[0];

        getDebitorCatalogue();
        getDebitorCatalogueDropdownList();
        getDebitorCatalogueForm(DebitorId);
        getCountriesList()
        //getDebitorCatalogueForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
        return translation[locale][key];
    }

    handleCreateNewAction = () => {
        this.setState({
            showModal: true,
            debitorAlreadyExist: false,
            percentExceed: false,
        })
    }

    handleCreateNewConf(buttonType) {
        const { getDebitorCatalogueForm } = this.props;
        if (buttonType === "ok") {
            getDebitorCatalogueForm();
            this.setState({
                showModalForm: true,
                showModal: false,
                isNew: true
            })
        } else {
            this.setState({ showModal: false })
        }
    }

    handleCloseFormModal = () => {
        this.setState({ showModalForm: false, contentIndex: Selected_Index.i_Zero, isNew: false })
        this.props.handleClose(false);
    }

    setPercentExceed = (value) => {
        this.setState({ percentExceed: value });
    };


    render() {
        const { contentIndex, activeTab, showModalForm, isNew, debitorAlreadyExist, percentExceed } = this.state;
        const {
            sortDebitorCatalogueItems,
            addDebitorCatalogueFilter,
            removeDebitorCatalogueFilter,
            setDebitorCatalogueColSearchStr,
            getDebitorCatalogue,
            debitorCatalogue,
            debitorCatalogueForm,
            saveDebitorCatalogueCustomCols,
            $form
        } = this.props;
        return (
            <>
                <ModalContainer
                    title="debitor_info"
                    show={this.props.showModalForm}
                    handleModal={this.handleCloseFormModal}
                    hideBtn={contentIndex === Selected_Index.i_One || !debitorCatalogue.isFetchFormLoaded ? true : false}
                    saveDetails={this.onClickSaveModal}
                    customClass="cost-allocation-details__modal modal-form__container"
                    disabled={false}
                    isReadAndWrite={''}
                    primaryBtnTooltip={"save_debitor_info"}
                >

                    <div className="data-table">
                        <DetailContainer
                            renderTabContent={this.handleSelectedIndex}
                            urlIndex={activeTab}
                            listTab={[
                                {
                                    "id": Selected_Index.i_Zero,
                                    "label": "Details",
                                    "hidden": false
                                },
                                {
                                    "id": Selected_Index.i_One,
                                    "label": "History",
                                    "hidden": false,
                                    "disable": isNew ? true : false
                                },

                            ]}
                        >
                            {contentIndex === Selected_Index.i_Zero &&
                                <DebitorDetailForm
                                debitorId={this.props.debitorId}
                                debitorAlreadyExist={debitorAlreadyExist}
                                percentExceed={percentExceed}
                                setPercentExceed={this.setPercentExceed}
                                debitorCatalogue={debitorCatalogue}
                                isViewing={this.props.isViewing}
                                />
                            }
                            {contentIndex === Selected_Index.i_One &&
                                <DebitorCatalogueHistory
                                    debitorId={debitorCatalogue.debitorCatalogueDetails.debitorId}
                                    //Access Type
                                    isReadOnly={''}
                                    isReadAndExtractOnly={''}
                                    isReadAndWrite={''}
                                    isViewing={this.props.isViewing}
                                />
                            }

                        </DetailContainer>
                    </div>

                </ModalContainer> 

            </>
        )
    }
}
export default withRouter(connect(
    state => {
        const { debitorCatalogue,
            form: { forms: { debitorCatalogueForm: { $form } } }
        } = state;
        const { debitorCatalogueForm } = state.form;
        return {
            debitorCatalogueForm
            , debitorCatalogue
            , translation
            , $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, debitorCatalogueActions),
        dispatch
    )
)(DebitorModal));
